import React from 'react';
import { DataPoint } from '../utils/mockData';
import { StatusIndicator } from './StatusIndicator';
import { TimeSlider } from './TimeSlider';
import { ClockIcon, ThermometerIcon } from 'lucide-react';
interface DashboardProps {
  data: DataPoint[];
  currentTimeIndex: number;
  setCurrentTimeIndex: (index: number) => void;
}
export const Dashboard: React.FC<DashboardProps> = ({
  data,
  currentTimeIndex,
  setCurrentTimeIndex
}) => {
  const currentData = data[currentTimeIndex];
  const formattedDate = currentData.timestamp.toLocaleString();
  return <div className="bg-white shadow rounded-lg" data-id="element-25">
      <div className="px-3 py-4 sm:px-4 sm:py-5 md:p-6" data-id="element-26">
        <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mb-4 sm:mb-6" data-id="element-27">
          Patient Health Monitor
        </h2>
        <div className="flex flex-col md:flex-row gap-4 sm:gap-6 mb-4 sm:mb-6" data-id="element-28">
          <div className="flex-1" data-id="element-29">
            <div className="bg-gray-50 p-3 sm:p-4 rounded-lg border border-gray-200" data-id="element-30">
              <div className="flex items-center mb-3 sm:mb-4 text-xs sm:text-sm" data-id="element-31">
                <ClockIcon className="h-4 w-4 sm:h-5 sm:w-5 text-gray-500 mr-1 sm:mr-2 flex-shrink-0" data-id="element-32" />
                <span className="font-medium text-gray-500 whitespace-nowrap mr-1" data-id="element-33">
                  Current Time:
                </span>
                <span className="text-gray-900 text-xs sm:text-sm" data-id="element-34">
                  {formattedDate}
                </span>
              </div>
              <h3 className="text-base sm:text-lg font-medium text-gray-900 mb-3 sm:mb-4" data-id="element-35">
                Current Wound Status
              </h3>
              <div className="flex justify-center mb-3 sm:mb-4" data-id="element-36">
                <StatusIndicator status={currentData.healthStatus} size="large" data-id="element-37" />
              </div>
              <div className="text-center mb-2" data-id="element-38">
                <span className="text-xs sm:text-sm font-medium text-gray-500" data-id="element-39">
                  Status:
                </span>
                <span className="ml-1 sm:ml-2 text-xs sm:text-sm font-medium" data-id="element-40">
                  {currentData.healthStatus === 'green' && <span className="text-green-600" data-id="element-41">Normal</span>}
                  {currentData.healthStatus === 'yellow' && <span className="text-yellow-600" data-id="element-42">Caution</span>}
                  {currentData.healthStatus === 'red' && <span className="text-red-600" data-id="element-43">Critical</span>}
                </span>
              </div>
            </div>
          </div>
          <div className="flex-1" data-id="element-44">
            <div className="bg-gray-50 p-3 sm:p-4 rounded-lg border border-gray-200" data-id="element-45">
              <h3 className="text-base sm:text-lg font-medium text-gray-900 mb-3 sm:mb-4" data-id="element-46">
                Wound Temperature
              </h3>
              <div className="flex items-center justify-center" data-id="element-47">
                <ThermometerIcon className="h-5 w-5 sm:h-6 sm:w-6 text-orange-500 mr-2 sm:mr-3 flex-shrink-0" data-id="element-48" />
                <div data-id="element-49">
                  <p className="text-sm sm:text-base font-medium text-gray-500" data-id="element-50">
                    Current Reading
                  </p>
                  <p className="text-lg sm:text-2xl font-semibold" data-id="element-51">
                    {currentData.vitalSigns.temperature}°F
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="bg-gray-50 p-3 sm:p-4 rounded-lg border border-gray-200 mb-4 sm:mb-6" data-id="element-52">
          <h3 className="text-base sm:text-lg font-medium text-gray-900 mb-3 sm:mb-4" data-id="element-53">
            Time Progression
          </h3>
          <TimeSlider data={data} currentIndex={currentTimeIndex} onChange={setCurrentTimeIndex} data-id="element-54" />
        </div>
      </div>
    </div>;
};